import { useEffect } from "react";
import { PhoneConfigs } from './constant';
import isDuo from "assets/hm_service_image/iphoneduo.png";
import isPro from "assets/hm_service_image/ts17pro.png";
import isProMax from "assets/hm_service_image/ts17promax.png";
import isAirPod from "assets/hm_service_image/isairpod.png";
import watchul4 from "assets/hm_service_image/watchul4.png";
import watchs12 from "assets/hm_service_image/watchs12.png";

const imageMap = {
  isProMax: isProMax,
  isPro: isPro,
  isDuo: isDuo,
  watchul4: watchul4,
  watchs12: watchs12,
  isAirPod: isAirPod
};

const imageMapMB = {
  isProMax: isProMax,
  isPro: isPro,
  isDuo: isDuo,
  watchul4: watchul4,
  watchs12: watchs12,
isAirPod: isAirPod
};

const ModalProduct = ({ open, onClose, productConfigs = PhoneConfigs }) => {
    useEffect(() => {
        const body = document.body;
        if (open) {
            body.style.overflow = "hidden";
        } else {
            body.style.overflow = "auto";
        }
    }, [open]);

    const productName = productConfigs?.productName || "";

    const productImage = imageMap[productConfigs];
    const productImageMB = imageMapMB[productConfigs];
   

    return (
        <div className="popup-notification p-attr">
            <div id="overlay" style={{ display: open ? 'flex' : 'none' }} className="overlay" onClick={onClose}></div>
            <div className="popup" id="popup" style={{ display: open ? 'block' : 'none' }}>
                <div className="content-popup for-homepage">
                    <img src={productImage} alt={productName} width="100%" className="f-desktop"/>
                    <img src={productImageMB} alt={productName} width="100%" className="f-mb"/>
                </div>
                <a className="closeButton" onClick={onClose}>
                    <svg
                        xmlns="http://www.w3.org/2000/svg"
                        width="26"
                        height="26"
                        viewBox="0 0 26 26"
                        fill="none"
                    >
                        <path
                            d="M6.502 6.50215C6.37586 6.62829 6.31278 6.77737 6.31278 6.94939C6.31852 7.12714 6.37872 7.27335 6.4934 7.38803L12.1097 13.0043L6.4934 18.6206C6.37299 18.741 6.31278 18.8872 6.31278 19.0592C6.31852 19.237 6.38159 19.386 6.502 19.5064C6.62241 19.6269 6.76862 19.6871 6.94064 19.6871C7.11265 19.6871 7.25886 19.6269 7.37927 19.5064L12.9955 13.8902L18.6118 19.5064C18.7322 19.6269 18.8784 19.6871 19.0505 19.6871C19.2225 19.6871 19.3716 19.624 19.4977 19.4978C19.6181 19.3774 19.6783 19.2312 19.6783 19.0592C19.6783 18.8872 19.6181 18.741 19.4977 18.6206L13.8814 13.0043L19.4977 7.38802C19.6181 7.26761 19.6783 7.1214 19.6783 6.94939C19.684 6.77164 19.6267 6.62256 19.5063 6.50215C19.3859 6.38174 19.2339 6.32153 19.0505 6.32153C18.8784 6.32153 18.7322 6.38174 18.6118 6.50215L12.9955 12.1184L7.37927 6.50215C7.2646 6.38747 7.11839 6.32727 6.94064 6.32153C6.76862 6.32153 6.62241 6.38174 6.502 6.50215Z"
                            fill="black"
                        />
                    </svg>
                </a>
            </div>
        </div>
    );
};

export default ModalProduct;
